<template>
  <div class="page-6-item">
    <div class="item-title">{{ title }}</div>
    <div class="item-text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: "Page6Item",
  props: {
    title: { type: String, required: true },
    text: { type: String, required: true },
  },
};
</script>

<style scoped>
.page-6-item {
  width: 100%;
  padding: 36px 40px;
  border-bottom: 1px solid #eee;
  transition: background 0.2s;
  border-radius: 8px;
  box-sizing: border-box;
}
.page-6-item:hover {
  background: #f8f9ff;
}
.page-6-item:last-child {
  border-bottom: none;
}

.item-title {
  font-size: 1.3rem;
  font-weight: 600;
  color: #1a1a2e;
  margin-bottom: 16px;
}

.item-text {
  font-size: 0.95rem;
  line-height: 1.8;
  color: #555;
  white-space: pre-wrap;
}

@media screen and (max-width: 768px) {
  .page-6-item {
    padding: 24px 16px;
  }
  .item-title {
    font-size: 1.1rem;
  }
  .item-text {
    font-size: 0.88rem;
  }
}
</style>
